// extracted by mini-css-extract-plugin
export default {"root":"gjf9hWCA5lV8mzZvxuLS","title":"_U8Q2irypBHDzDoCzQLk","question":"ILT4JH1dSA1ikFJUYgZS","footer":"PrECOXLV27Y4ZAvTxsvP"};